import { Controller } from '@hotwired/stimulus';

// Below lg the peek sheet scrolls the document over a fixed map. Pulling the sheet past either end
// would rubber-band the whole page in iOS Safari, dragging the map with it, and overscroll-behavior
// does not stop that there, so drags that would overscroll are cancelled instead.
class PeekSheetController extends Controller {
  private startY = 0;
  private readonly desktop = window.matchMedia('(min-width: 992px)');

  private readonly _onTouchStart = (event: TouchEvent): void => {
    const [touch] = event.touches;

    this.startY = touch.clientY;
  };

  private readonly _onTouchMove = (event: TouchEvent): void => {
    const [touch] = event.touches;
    const target = event.target as Node;

    if (
      !event.cancelable ||
      event.touches.length !== 1 ||
      this.desktop.matches ||
      !this.element.contains(target)
    ) {
      return;
    }

    const delta = touch.clientY - this.startY;
    const atTop = window.scrollY <= 0;
    const atBottom =
      window.scrollY + window.innerHeight >=
      document.documentElement.scrollHeight - 1;

    if ((atTop && delta > 0) || (atBottom && delta < 0)) {
      event.preventDefault();
    }
  };

  public connect(): void {
    document.addEventListener('touchstart', this._onTouchStart, {
      passive: true
    });
    document.addEventListener('touchmove', this._onTouchMove, {
      passive: false
    });
  }

  public disconnect(): void {
    document.removeEventListener('touchstart', this._onTouchStart);
    document.removeEventListener('touchmove', this._onTouchMove);
  }
}

export default PeekSheetController;
